import type { CompanyFilter } from './companyFilter.ts';

// Builds the Vendors-list URL a dashboard tile links to, carrying the active
// dashboard search (q) + filters so the list lands pre-filtered. Maps to the
// params Companies.tsx already parses: status, type, region, station, q.
export function dashboardListUrl(
  tileStatus: string,
  query: string,
  filter: CompanyFilter,
): string {
  const params = new URLSearchParams();
  // Always set status, including the 'all' tile. Omitting it made the "All
  // vendors" link a BARE /vendors — byte-identical to the sidebar link, which
  // is a filter-restore trigger (vendorFilterParams.ts), so the tile showing
  // "All vendors — 412" would land on a list of 3 restored from an old
  // station filter. `?status=all` costs nothing: parseStatusFilterParam maps
  // any non-CompanyStatus value to 'all', so the list renders identically and
  // filtersActive stays false — but hasVendorFilterParams now sees a filter
  // key, which is what suppresses the restore.
  params.set('status', tileStatus);
  const q = query.trim();
  if (q) params.set('q', q);
  for (const t of filter.contractorTypes) params.append('type', t);
  for (const r of filter.clusterRegions) params.append('region', r);
  for (const s of filter.stations) params.append('station', s);
  const qs = params.toString();
  return qs ? `/vendors?${qs}` : '/vendors';
}
